import { httpResource } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HierarchyDto } from '@api-types/dtos/create-analysis-configuration.dto';
import { ControlsOf } from '@api-types/helper/helper';
import { LoadingFailedHintComponent } from '@libs/ui';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { CreateAnalysisConfigurationBaseStepComponent } from 'demand-forecasting/analysis/components/configuration/steps/base-create-analysis-configuration-step-component.interface';
import { DragAndDropHierarchyComponent } from 'demand-forecasting/analysis/components/configuration/steps/hierarchy-step-analysis-configuration/drag-and-drop-hierarchy/drag-and-drop-hierarchy.component';
import { selectConfigurationId } from 'demand-forecasting/store/router-state/router.selectors';

@Component({
  selector: 'pm-hierarchy-step-analysis-configuration',
  templateUrl: './hierarchy-step-analysis-configuration.component.html',
  imports: [
    ReactiveFormsModule,
    DragAndDropHierarchyComponent,
    TranslateModule,
    LoadingFailedHintComponent,
    MatProgressSpinnerModule,
  ],
})
export class HierarchyStepAnalysisConfigurationComponent extends CreateAnalysisConfigurationBaseStepComponent<HierarchyDto> {
  private readonly store = inject(Store);
  private readonly configurationId = this.store.selectSignal(
    selectConfigurationId,
  );

  form: FormGroup<ControlsOf<HierarchyDto>> = this.fb.group({
    hierarchyOrder: this.fb.control<string[]>([], {
      validators: [
        Validators.required,
        // at least 1 item in array
        (control) =>
          control.value?.length >= 1
            ? null
            : {
                minArrayLength: {
                  required: 1,
                  actual: control.value?.length ?? 0,
                },
              },
      ],
      nonNullable: true,
    }),
  });

  protected readonly groupColumns = httpResource<string[]>(() => {
    const configurationId = this.configurationId();
    if (!configurationId) return undefined;
    return `${environment.api.url}/analysis/configurations/${configurationId}/group-columns`;
  });
}
